export enum EntityEnum {
        Practice = 67,
        Aht = 69,
        Hospital = 70,
}
